import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// 引入 Vue2 版 Element UI（你项目原本就有的）
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')